import { LoadingButton } from "@mui/lab";
import {
    Alert,
    Stack,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
} from "@mui/material";
import { ChangeEvent, useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SaleDto, SaleStatus } from "../../../api/psc";
import {
    DialogContainer,
    DialogHeader,
    PrivilegeAlert,
} from "../../../components/exports";
import { UserAccessTypes } from "../../../components/shared/PrivilegeAlert";
import { DialogContext } from "../../../contexts/DialogContext";
import { updateSaleThunk } from "../../../slices/SalesSlice";
import { RootState } from "../../../slices/Store";

export default function UpdateSaleDialog(props: { sale: SaleDto }) {
    const dispatch = useDispatch();
    const saleState = useSelector((state: RootState) => state.salesState);

    const { closeDialog } = useContext(DialogContext);

    const [saleStatus, setSaleStatus] = useState(props.sale.status);
    const [description, setDescription] = useState(props.sale.description);
    const [requestInProgress, setRequestInProgress] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleDescriptionChange = (event: ChangeEvent<HTMLInputElement>) => {
        setDescription(event.target.value);
    };

    const handleSaleStatusChange = (
        event: React.MouseEvent<HTMLElement>,
        value: SaleStatus | null
    ) => {
        if (value === null) {
            return;
        }
        setSaleStatus(value);
    };

    const updateSale = async () => {
        setRequestInProgress(true);

        const result = await updateSaleThunk(
            props.sale.id,
            {
                description: description,
                status: saleStatus,
            },
            saleState,
            dispatch
        );

        setRequestInProgress(false);

        if (result.error) {
            setError(result.error.getFirstError());
        } else {
            closeDialog();
        }
    };

    return (
        <DialogContainer>
            <DialogHeader title="ویرایش فرایند فروش" />

            <PrivilegeAlert access={UserAccessTypes.ManageSales} />

            <Stack spacing={2} sx={{ p: 2 }}>
                <ToggleButtonGroup
                    color="primary"
                    value={saleStatus}
                    fullWidth
                    exclusive
                    onChange={handleSaleStatusChange}
                >
                    <ToggleButton color="error" value={SaleStatus.CANCELLED}>
                        کنسل شده
                    </ToggleButton>
                    <ToggleButton color="primary" value={SaleStatus.PENDING}>
                        در انتظار
                    </ToggleButton>
                    <ToggleButton color="success" value={SaleStatus.DONE}>
                        پایان یافته
                    </ToggleButton>
                </ToggleButtonGroup>

                <TextField
                    sx={{ mb: 2 }}
                    value={description}
                    fullWidth
                    label="توضیحات"
                    multiline
                    onChange={handleDescriptionChange}
                    rows={3}
                    maxRows={6}
                />

                {error && <Alert severity="error">{error}</Alert>}

                <LoadingButton
                    fullWidth
                    loading={requestInProgress}
                    onClick={updateSale}
                    variant="contained"
                >
                    ویرایش فرایند فروش
                </LoadingButton>
            </Stack>
        </DialogContainer>
    );
}
